import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ReactDatePicker from 'react-datepicker'
import classnames from 'classnames'

import { ButtonAction, ACTION_BUTTON_TYPE_ADD } from '../ButtonAction'

import DatePickerButtonContainer from './DatePicker.styles'

/*
import de from 'date-fns/locale/de'
import en from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'
import fr from 'date-fns/locale/fr'
import id from 'date-fns/locale/id'
import it from 'date-fns/locale/it'
import ja from 'date-fns/locale/ja'
import pt from 'date-fns/locale/pt'
import zh from 'date-fns/locale/zh-CN'

import 'react-datepicker/dist/react-datepicker.css'
import './DatePicker.scss'

registerLocale('da', en)
registerLocale('de', de)
registerLocale('en', en)
registerLocale('es', es)
registerLocale('fr', fr)
registerLocale('id', id)
registerLocale('it', it)
registerLocale('ja', ja)
registerLocale('pt', pt)
registerLocale('zh', zh)
*/

export const DatePickerButton = ({
  value,
  onChange,
  tooltip,
  className,

  disabled,
  maxDate,
  minDate,

  locale,

  'data-mu-test': dataAttributeTest
}) => {
  const [open, setOpen] = useState(false)

  const handleCalendarClose = () => {
    setOpen(false)
  }
  const handleCalendarOpen = () => {
    setOpen(true)
  }

  return (
    <DatePickerButtonContainer
      className={className}
      data-mu-test={classnames('datepicker-button', dataAttributeTest)}
    >
      <ReactDatePicker
        selected={value}
        onChange={onChange}
        customInput={<DatePickerInput disabled={disabled} tooltip={tooltip} open={open} />}
        className='c-datepicker__input'
        disabled={disabled}
        isClearable={false}
        minDate={minDate}
        maxDate={maxDate}
        autoComplete='off'
        onCalendarClose={handleCalendarClose}
        onCalendarOpen={handleCalendarOpen}
        locale={locale}
      />
    </DatePickerButtonContainer>
  )
}

/* Please see: https://github.com/Hacker0x01/react-datepicker/issues/862 */
const DatePickerInput = React.forwardRef(
  ({ disabled, tooltip, onClick, open }, _ref) => {
    return (
      <ButtonAction
        type={ACTION_BUTTON_TYPE_ADD}
        onClick={onClick}
        disabled={disabled}
        tooltip={tooltip}
        className={classnames('c-datepicker-button', {
          'c-datepicker-button--active': open
        })}
      />
    )
  }
)

DatePickerInput.defaultProps = {
  disabled: false
}

DatePickerInput.propTypes = {
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  onClick: PropTypes.func,
  open: PropTypes.bool,

}

DatePickerButton.defaultProps = {
  value: null,
  disabled: false,
  locale: 'en'
}

DatePickerButton.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  tooltip: PropTypes.string,
  className: PropTypes.string,

  disabled: PropTypes.bool,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  locale: PropTypes.string,

  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
